import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
    tabItem: 'js-o-teaser-tabs__item',
    tabContent: 'js-o-teaser-tabs__content',
};

@createModule('TeaserTabs')
export class TeaserTabs extends TerrificSpec {
    $ctx: JQuery;
    $tabItem: JQuery;
    $tabContent: JQuery;

    start(resolve: Function) {
        const _this = this;
        this.$ctx = $(this._ctx);
        this.$tabItem = $(`.${classes.tabItem}`, this.$ctx);
        this.$tabContent = $(`.${classes.tabContent}`, this.$ctx);
        this.$tabItem.on("click", function (ev: any) {
			_this.updatestatus($(ev.currentTarget));
            _this.updateUri(ev);
		});
        this.initTab();
        resolve();
    }

    stop() {
    }

    initTab() {
        const _this = this;
        this.removeActiveCalss();
        this.$tabItem.first().addClass('active');
        this.$tabContent.first().addClass('active');

        if (window.location.search.length > 1) {
            let parts = location.search.substr(1).split('&');
            for (let i = 0; i < parts.length; i++) {
                const keyValue = parts[i].split('=', 2);
                if (keyValue.length != 2) continue;
                const key = keyValue[0];
                const value = keyValue[1];
                if (key === "tab") {
                    if(this.$ctx.find(`.${classes.tabItem}`).length>parseInt(value))
                    {
                      _this.updatestatus($(this.$ctx.find(`.${classes.tabItem}`)[parseInt(value)]));
                    }
                    else
                    {
                        _this.updatestatus($(this.$ctx.find(`.${classes.tabItem}`).last()));
                    }
                } 
            }
        }
    }

    removeActiveCalss() {
        this.$tabItem.removeClass('active');
        this.$tabContent.removeClass('active');
    }

    private updatestatus(ev: any):void
    {
        const $target: any = ev;
        const $url:any=document.location;
        $target.siblings().each( function () {
            if($(this).hasClass('active'))
            {
                $(this).attr("data-tab-link",$url);
            }
        });
        this.removeActiveCalss();
        $target.siblings().removeClass('active');
        $target.addClass('active');
        this.$tabContent.removeClass('active');
		this.$tabContent.eq($target.index()).addClass('active');
    }

    private updateUri(ev: any): void {
                const $target: any = $(ev.currentTarget);
        
             var parts: string[] = [];
             const _this = this;
             parts.push(`tab=${$target.index()}`);
             let url = document.location.origin + document.location.pathname;
             if(document.location.href.indexOf("?") !== -1) {
                url = url + document.location.search;
                const keyValue = parts[0].split('=', 2);
                if (parts.length > 0 && keyValue[0] === "tab") 
                {
                    for (let i = 0; i < parts.length; i++) {
                        const keyValue = parts[i].split('=', 2);
                        if (keyValue.length != 2) continue;
                        const key = keyValue[0];
                        const value = keyValue[1];
                        if (key === "tab") {
                           var splitUrl = url.split("?");
                           splitUrl.pop();
                           url = splitUrl + "?" + parts[0].toString();
                        } 
                    }
                }
               /*  else
                {
                  url += parts.join("&");
                }
                */

            }
              /*  else{
                if (parts.length > 0) url += "?" + parts.join("&");
               }
               */
             history.replaceState(null, document.title, url);
        
    }
}